import Report from '../Report';
import FieldSet from '../FieldSet';
import Parameter from '../Parameter';

export default class NumberField extends Parameter {
    // Valeur d'incrémentation
    public Step: string;

    /**
     * Constructeur Number pas Vraiment Utile le Number => Spinner
     * @param Name 
     * @param Label 
     * @param Type 
     * @param EmptyText 
     * @param Selected 
     * @param Option 
     * @param Listeners 
     * @param Step Extends
     */
    constructor(Name: string = '', Label: string = '', Type: string = 'Number', EmptyText: string = '', Selected: string = '', Option: object = {}, Listeners: Array<{ key: string; value: string }> = [], Step: string = '') {
        super(Name, Label, Type, EmptyText, Selected, Option, Listeners);
        this.Step = Step;
    }

    //#region Methode Static
    
    // Enregistre la sous-class dans la class Parent
    // static {
    //     Parameter.registerSubclass(NumberField); 
    // }

    //#endregion
    
    /**
     * Check si Number à des valeurs
     * @returns boolean
     */
    override HasValue(): boolean {
        return this.Step != null;
    }
    
    /**
     * Propriété filtrées pour la création d'un objet Number
     * @returns Dictionnaires Nom / Valeurs
     */
    override getProperties(): Array<[string, any]>{
        return Object.entries(this).filter(([key]) => 
            this.keysToFilter.includes(key) )
    }

    // Créations des clé pour filtrer les propriété de Number
    override keysToFilter: string[] =  ['Label', 'Step'];

    override create() : NumberField{
        return new NumberField(this.Name, this.Label, this.Type, this.EmptyText, this.Selected, this.Option, this.Listeners, this.Step)
    }
}